module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("是否删除这条评论?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.makesure()
      }
    }
  }, [_vm._v("确 定")])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "region",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("评论管理")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "height": "auto"
    },
    attrs: {
      "data": _vm.goodListInfo,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "CommentatorName",
      "label": "评论用户",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.CommentatorName
          }
        }, [_vm._v(_vm._s(scope.row.CommentatorName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "UserType",
      "label": "用户身份",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.UserType
          }
        }, [_vm._v(_vm._s(scope.row.UserType))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CContent",
      "align": "center",
      "label": "评论内容"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.CContent
          }
        }, [_vm._v(_vm._s(scope.row.CContent))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CTime",
      "align": "center",
      "label": "评论时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.CTime
          }
        }, [_vm._v(_vm._s(scope.row.CTime))])]
      }
    }])
  }), _vm._v(" "), (_vm.BbId == 1 || _vm.userType == 5) ? _c('el-table-column', {
    attrs: {
      "prop": "BrandName",
      "fixed": "right",
      "align": "center",
      "width": "100",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.deleteBut(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v("\r\n                删除\r\n          ")])]
      }
    }], null, false, 2331363508)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0accc11c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/shopcomment.vue
// module id = 1630
// module chunks = 3